import { createAction, ActionType, createReducer } from 'typesafe-actions';

interface YoutubeReducer {
  [key: string]: {
    [key: string]: {
      link: string;
      name: string;
    };
  };
}

const initialState: YoutubeReducer = {
  student: {
    root: {
      link: 'https://youtu.be/KAtYihcwW-0 ',
      name: '출결버스 매뉴얼',
    },
    teacher: {
      link: 'https://youtu.be/KAtYihcwW-0 ',
      name: '출결버스 매뉴얼',
    },
    class: {
      link: 'https://youtu.be/KAtYihcwW-0 ',
      name: '출결버스 매뉴얼',
    },
    list: {
      link: 'https://youtu.be/KAtYihcwW-0 ',
      name: '출결버스 매뉴얼',
    },
    registration: {
      link: 'https://youtu.be/KAtYihcwW-0 ',
      name: '출결버스 매뉴얼',
    },
    study: {
      link: 'https://youtu.be/KAtYihcwW-0 ',
      name: '출결버스 매뉴얼',
    },
  },
  attendance: {
    root: {
      link: 'https://youtu.be/KAtYihcwW-0 ',
      name: '출결버스 매뉴얼',
    },
    status: {
      link: 'https://youtu.be/KAtYihcwW-0 ',
      name: '출결버스 매뉴얼',
    },
    manager: {
      link: 'https://youtu.be/KAtYihcwW-0 ',
      name: '출결버스 매뉴얼',
    },
    sms: {
      link: 'https://youtu.be/KAtYihcwW-0 ',
      name: '출결버스 매뉴얼',
    },
    covid: {
      link: 'https://youtu.be/KAtYihcwW-0 ',
      name: '출결버스 매뉴얼',
    },
  },
  sms: {
    root: {
      link: 'https://youtu.be/KAtYihcwW-0 ',
      name: '출결버스 매뉴얼',
    },
    send: {
      link: 'https://youtu.be/KAtYihcwW-0 ',
      name: '출결버스 매뉴얼',
    },
    detail: {
      link: 'https://youtu.be/KAtYihcwW-0 ',
      name: '출결버스 매뉴얼',
    },
    reservation: {
      link: 'https://youtu.be/KAtYihcwW-0 ',
      name: '출결버스 매뉴얼',
    },
  },
  setup: {
    root: {
      link: 'https://youtu.be/KAtYihcwW-0 ',
      name: '출결버스 매뉴얼',
    },
    info: {
      link: 'https://youtu.be/KAtYihcwW-0 ',
      name: '출결버스 매뉴얼',
    },
    phone: {
      link: 'https://youtu.be/KAtYihcwW-0 ',
      name: '출결버스 매뉴얼',
    },
    receipt: {
      link: 'https://youtu.be/KAtYihcwW-0 ',
      name: '출결버스 매뉴얼',
    },
    check: {
      link: 'https://youtu.be/KAtYihcwW-0 ',
      name: '출결버스 매뉴얼',
    },
    service: {
      link: 'https://youtu.be/KAtYihcwW-0 ',
      name: '출결버스 매뉴얼',
    },
  },
  cash: {
    root: {
      link: 'https://youtu.be/KAtYihcwW-0 ',
      name: '출결버스 매뉴얼',
    },
    charge: {
      link: 'https://youtu.be/KAtYihcwW-0 ',
      name: '출결버스 매뉴얼',
    },
    'charge-detail': {
      link: 'https://youtu.be/KAtYihcwW-0 ',
      name: '출결버스 매뉴얼',
    },
    'use-detail': {
      link: 'https://youtu.be/KAtYihcwW-0 ',
      name: '출결버스 매뉴얼',
    },
  },
  account: {
    root: {
      link: 'https://youtu.be/zgX0hBz7Vpw',
      name: '영상 > 청구대상 관리',
    },
    check: {
      link: 'https://youtu.be/zgX0hBz7Vpw',
      name: '영상 > 청구대상 관리',
    },
    manage: {
      link: 'https://youtu.be/4s1Ow5xy98Q',
      name: '영상 > 청구내역 조회',
    },
    create: {
      link: 'https://youtu.be/4s1Ow5xy98Q',
      name: '영상 > 청구내역 조회',
    },
    statistics: {
      link: 'https://youtu.be/tMQxPpTJUjg',
      name: '영상 > 수납통계 조회',
    },
    calculate: {
      link: '',
      name: '',
    },
    sms: {
      link: '',
      name: '',
    },
  },
};

export const CLEAR_LINK = 'YoutubeReducer/CLEAR_LINK';
export const SET_LINK = 'YoutubeReducer/SET_LINK';

export const clearPath = createAction(CLEAR_LINK)();
export const setLink = createAction(SET_LINK)<YoutubeReducer>();

export const actions = { clearPath, setLink };
type YoutubeReducerActions = ActionType<typeof actions>;

const YoutubeReducer = createReducer<YoutubeReducer, YoutubeReducerActions>(initialState, {
  [CLEAR_LINK]: state => {
    return {
      ...initialState,
    };
  },
  [SET_LINK]: (state, action) => {
    const cur_state = {
      ...state,
      ...action.payload,
    };

    return cur_state;
  },
});

export default YoutubeReducer;
